jQuery(document).ready(function () {
  jQuery('.brz-wrapper-clone[data-button-annotation]').each(function () {
    var $container = jQuery(this);
    var annotationText = $container.attr('data-button-annotation');

    // first button inside the container
    var $firstButton = $container.find('.brz-btn').first();
    if (!$firstButton.length) return;

    // create annotation
    var $annotationDiv = jQuery(
      '<div class="mad-button-annotation" style="opacity:0;">' + annotationText + '</div>'
    );

    // insert annotation after first button
    $firstButton.after($annotationDiv);

    // wrap button + annotation together so annotation can center under button 1
    $firstButton.add($annotationDiv).wrapAll('<span class="mad-button-wrap"></span>');

    // animate in
    $annotationDiv.animate({ opacity: 1 }, 500);
  });
});